import type { ReactNode } from 'react'

/** The white rounded card shell every dashboard widget sits in: a header
 * (title + optional right-aligned control) and a body. */
export default function SectionCard({
  title,
  action,
  children,
  className = '',
  bodyClassName = '',
}: {
  title: ReactNode
  action?: ReactNode
  children: ReactNode
  className?: string
  bodyClassName?: string
}) {
  return (
    <div className={`bg-white rounded-xl border border-gray-100 shadow-sm ${className}`}>
      <div className="flex flex-wrap items-center justify-between gap-x-3 gap-y-2 px-4 sm:px-5 py-3.5 border-b border-gray-100">
        <h2 className="text-sm font-semibold text-gray-800">{title}</h2>
        {action}
      </div>
      <div className={`p-4 sm:p-5 ${bodyClassName}`}>{children}</div>
    </div>
  )
}
